// CrewZNatioN — Builds Knowledge Base
// Source of truth for the marquee items, detail-page routes, and full editorial content.
//
// type:           "car" | "motorcycle"
// Flagship entries (have `engine`) get the full editorial page.
// Stub entries (most) carry minimum fields used by the marquee + a basic detail page.
//
// MOD SCHEMA (flagship):
//   commonMods: [
//     {
//       area: "Engine",
//       items: [
//         { part: "MSS54 Software Tune", vendors: [
//           { name: "Epic Motorsports", url: "https://..." }, ... (top 3)
//         ]},
//         ...
//       ]
//     }, ...
//   ]
// Images are sourced from Wikimedia Commons (CC-licensed) for accuracy.

export const BUILDS = [
    // ============ TOYOTA SUPRA MK4 ============
    {
        slug: "supra-mk4-a80",
        name: "Toyota Supra MK4",
        fullName: "Toyota Supra MK4 (A80)",
        manufacturer: "Toyota",
        type: "car",
        category: "JDM",
        years: "1993 – 2002",
        engine: "2JZ-GTE · 3.0L Twin-Turbo Inline-6",
        horsepower: "320 hp (JDM) · 1,000+ hp common with built block",
        drivetrain: "RWD · 6-Speed Getrag V160 Manual / 4-Speed Auto",
        bodyType: "2+2 Coupe",
        weight: "1,510 kg (Stock)",
        zeroToSixty: "4.6 s (Stock)",
        images: [
            { url: "https://wallpapercave.com/wp/wp12081851.jpg", label: "Hero — Red Modified Supra MK4" },
            { url: "https://wallpapercave.com/wp/wp9662929.jpg", label: "Rear — Dual Taillights, Twin Exhaust" },
            { url: "https://wallpapercave.com/wp/wp12267681.jpg", label: "White MK4 — Clean Build" },
            { url: "https://wallpapercave.com/wp/wp12110580.jpg", label: "Black On Black Rims" },
            { url: "https://wallpapercave.com/wp/wp4172415.jpg", label: "2JZ-GTE Engine Bay — Twin Turbo" },
            { url: "https://wallpapercave.com/wp/wp4172462.jpg", label: "2JZ JZA80 Engine Detail" },
            { url: "https://wallpapercave.com/wp/wp4172478.jpg", label: "Supra Engine Bay — Build Spec" },
            { url: "https://wallpapercave.com/wp/wp4172445.jpg", label: "Driftmotion Supra Engine" },
            { url: "https://wallpapercave.com/wp/wp2569417.jpg", label: "Sunset Highway" },
        ],
        whyItsIcon:
            "The MK4 Supra Is The Definition Of A Modern JDM Legend. The 2JZ-GTE's Closed-Deck Iron Block And Forged Internals Mean It Tolerates Massive Boost Without Touching The Bottom End — Which Is Why Built Supras Routinely Push Four-Digit Horsepower On Stock Crank And Rods. Cemented Forever By The Fast & Furious Era, And Reborn With The 1,000 HP Drag Builds Of The 2000s, It Remains The Holy Grail Of Inline-Six Tuning Culture.",
        commonMods: [
            { area: "Engine", items: [
                { part: "Single Turbo Conversion (Precision 6266 / Borg Warner EFR)", vendors: [
                    { name: "Real Street Performance", url: "https://realstreetperformance.com" },
                    { name: "Driftmotion", url: "https://www.driftmotion.com/search.php?search_query=precision" },
                    { name: "Driftmotion", url: "https://www.driftmotion.com" },
                ]},
                { part: "Built Internals (Forged Pistons, Rods, ARP Studs)", vendors: [
                    { name: "Summit Racing (CP-Carrillo)", url: "https://www.summitracing.com/search?q=cp+carrillo" },
                    { name: "Summit Racing (Manley)", url: "https://www.summitracing.com/search?q=manley" },
                    { name: "Summit Racing (ARP)", url: "https://www.summitracing.com/search?q=arp" },
                ]},
                { part: "Standalone ECU (AEM Infinity / Haltech Elite)", vendors: [
                    { name: "Summit Racing", url: "https://www.summitracing.com/search?q=aem" },
                    { name: "Real Street Performance", url: "https://realstreetperformance.com/search.php?search_query=haltech" },
                    { name: "MoTeC", url: "https://www.motec.com" },
                ]},
                { part: "E85 / Methanol Conversion Fuel System", vendors: [
                    { name: "Summit Racing", url: "https://www.summitracing.com/search?q=injector+dynamics" },
                    { name: "Radium Engineering", url: "https://www.radiumauto.com" },
                    { name: "Summit Racing", url: "https://www.summitracing.com/search?q=aem" },
                ]},
            ]},
            { area: "Drivetrain", items: [
                { part: "TH400 / Powerglide Drag Conversion", vendors: [
                    { name: "RPM Transmissions", url: "https://rpmtransmissions.com" },
                    { name: "TCI Auto", url: "https://www.tciauto.com" },
                    { name: "ATI Performance", url: "https://atiracingproducts.com" },
                ]},
                { part: "ACT Twin-Disc Clutch", vendors: [
                    { name: "Summit Racing (ACT)", url: "https://www.summitracing.com/search?q=act+clutch" },
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=os+giken" },
                    { name: "Driftmotion", url: "https://www.driftmotion.com" },
                ]},
                { part: "OS Giken / Quaife LSD", vendors: [
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=os+giken" },
                    { name: "Z1 Motorsports", url: "https://www.z1motorsports.com/search.php?search_query=quaife" },
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=cusco" },
                ]},
            ]},
            { area: "Suspension", items: [
                { part: "KW Clubsport / HKS Hipermax Coilovers", vendors: [
                    { name: "Tire Rack", url: "https://www.tirerack.com/suspension/index.jsp?brand=KW" },
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=hks" },
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=tein" },
                ]},
                { part: "Cusco Sway Bars + Pillow Mounts", vendors: [
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=cusco" },
                    { name: "Summit Racing (Whiteline)", url: "https://www.summitracing.com/search?q=whiteline" },
                    { name: "Summit Racing (Hotchkis)", url: "https://www.summitracing.com/search?q=hotchkis" },
                ]},
            ]},
            { area: "Brakes", items: [
                { part: "Brembo GT 6-Piston Big Brake Kit", vendors: [
                    { name: "Tire Rack (Brembo)", url: "https://www.tirerack.com/brakes/index.jsp?brand=Brembo" },
                    { name: "Tire Rack (StopTech)", url: "https://www.tirerack.com/brakes/index.jsp?brand=StopTech" },
                    { name: "Essex Parts (AP Racing)", url: "https://essexparts.com" },
                ]},
                { part: "Pagid / Hawk Track Pads", vendors: [
                    { name: "Essex Parts (Pagid)", url: "https://essexparts.com" },
                    { name: "Summit Racing (Hawk)", url: "https://www.summitracing.com/search?q=hawk+pads" },
                    { name: "Project Mu USA", url: "https://www.projectmuusa.com" },
                ]},
            ]},
            { area: "Aero / Exterior", items: [
                { part: "TRD 3000GT Aero Kit", vendors: [
                    { name: "Toyota TRD", url: "https://www.toyota.com/trdperformanceparts" },
                    { name: "Driftmotion", url: "https://www.driftmotion.com" },
                    { name: "Garage Active (Japan)", url: "https://garage-active.com" },
                ]},
                { part: "Volk TE37 / Work Meister Wheels", vendors: [
                    { name: "Mackin Industries (Rays Dist.)", url: "https://www.mackinindustries.com" },
                    { name: "Wheel Pros (Work USA)", url: "https://workwheelsusa.com/find-a-dealer/" },
                    { name: "Tire Rack (BBS)", url: "https://www.tirerack.com/wheels/index.jsp?brand=BBS" },
                ]},
            ]},
        ],
        interiorMods: [
            "Bride / Recaro Pro Racer Bucket Seats",
            "Takata 4-Point Harnesses",
            "Defi BF Boost / Oil / Water Temp Cluster",
            "AEM CD-7 Digital Dash",
            "Carbon Trim Pieces / Suede Steering Wheel",
        ],
        knownIssues: [
            {
                title: "VVTi Oil Line Failure",
                summary: "Original Banjo Oil Line To VVTi Solenoid Cracks With Age, Causing A Sudden Loss Of Oil Pressure That Can Destroy The Top End.",
                fix: "Replace OEM Rubber Line With A Stainless-Braided Line Within The First Service. ~$60 Part, 30-Min Job.",
                videoUrl: "https://www.youtube.com/results?search_query=2jz+vvti+oil+line+replacement+stainless+braided",
            },
            {
                title: "Rear Differential Bushings",
                summary: "Stock Bushings Compress Under Aggressive Launches Causing Clunks And Toe Movement.",
                fix: "Whiteline / Cusco Polyurethane Bushings Solve The Issue Permanently.",
                videoUrl: "https://www.youtube.com/results?search_query=mk4+supra+rear+differential+bushing+replacement",
            },
            {
                title: "BPU Boost Creep",
                summary: "On Sequential-Turbo Removal (BPU), Stock Wastegates Cannot Bleed Enough Pressure At High RPM.",
                fix: "Add A Manual Boost Controller And HKS Wastegate Actuator; Use A Tuned ECU.",
                videoUrl: "https://www.youtube.com/results?search_query=supra+2jz+boost+creep+wastegate+fix",
            },
        ],
        resources: {
            forums: [
                { label: "Supraforums.com — The OG Community", url: "https://www.supraforums.com" },
                { label: "MKIVSupra.net", url: "https://www.mkivsupra.net" },
                { label: "r/Supra", url: "https://www.reddit.com/r/Supra/" },
            ],
            youtube: [
                { label: "Real Street Performance", url: "https://www.youtube.com/@realstreetperformance" },
                { label: "Boostin Performance", url: "https://www.youtube.com/@boostinperformance" },
                { label: "Larry Chen — Supra Builds", url: "https://www.youtube.com/@larrychenphoto" },
            ],
            partsRetailers: [
                { label: "Real Street Performance", url: "https://realstreetperformance.com" },
                { label: "Driftmotion (Supra Specialists)", url: "https://www.driftmotion.com" },
                { label: "AMS Performance", url: "https://www.amsperformance.com" },
                { label: "HKS USA", url: "https://www.hksusa.com" },
            ],
        },
    },

    // ============ NISSAN SKYLINE GT-R R34 ============
    {
        slug: "skyline-gtr-r34",
        name: "Nissan Skyline GT-R R34",
        fullName: "Nissan Skyline GT-R R34 (BNR34)",
        manufacturer: "Nissan",
        type: "car",
        category: "JDM",
        years: "1999 – 2002",
        engine: "RB26DETT · 2.6L Twin-Turbo Inline-6",
        horsepower: "276 hp (Gentleman's Agreement) · 600+ hp common with Stage 2",
        drivetrain: "ATTESA E-TS Pro AWD · 6-Speed Getrag Manual",
        bodyType: "2-Door Coupe",
        weight: "1,560 kg",
        zeroToSixty: "4.9 s (Stock)",
        images: [
            { url: "https://wallpapercave.com/wp/wp4107637.jpg", label: "Hero — Bayside Blue R34 Profile" },
            { url: "https://wallpapercave.com/wp/wp10145496.jpg", label: "Rear — Iconic R34 Four-Taillights" },
            { url: "https://wallpapercave.com/wp/wp4107705.jpg", label: "GT-R Wide — Magazine Shoot" },
            { url: "https://wallpapercave.com/wp/wp4107670.jpg", label: "Tuned Front Three-Quarter" },
            { url: "https://wallpapercave.com/wp/wp4107682.jpg", label: "Modified Front Detail" },
            { url: "https://wallpapercave.com/wp/wp2727016.jpg", label: "Urban Street Wide" },
            { url: "https://wallpapercave.com/wp/wp6820915.jpg", label: "RB26DETT Engine Bay" },
            { url: "https://wallpapercave.com/wp/wp6821024.jpg", label: "R34 RB26 Engine Detail" },
            { url: "https://wallpapercave.com/wp/wp6808571.jpg", label: "RB26DETT — Build Spec" },
            { url: "https://wallpapercave.com/wp/wp6820984.jpg", label: "RB26 — Inline-6 Detail" },
        ],
        whyItsIcon:
            "Godzilla. The R34 Closed The Skyline GT-R Lineage With The Most Refined Form Of The RB26 — A Hand-Assembled Twin-Turbo Inline-Six With Closed-Deck Construction And Six Individual Throttle Bodies. The ATTESA E-TS Pro AWD With Active LSD Made It Untouchable On A Wet Touge. Combine That With Nismo's V-Spec II Nür Aero, The Multifunction Display From Gran Turismo, And A Cult That Stretches From Japan To Riyadh — And You Get The Most Sought-After Build Platform On The Planet.",
        commonMods: [
            { area: "Engine", items: [
                { part: "Tomei / HKS RB28 Stroker Kit", vendors: [
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=tomei" },
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=hks" },
                    { name: "Nismo Heritage Parts", url: "https://www.nismo.co.jp/products/heritage_parts/" },
                ]},
                { part: "Garrett GTX3582R Twin Turbos / Single Conversion", vendors: [
                    { name: "Real Street Performance", url: "https://realstreetperformance.com/search.php?search_query=garrett" },
                    { name: "Driftmotion", url: "https://www.driftmotion.com/search.php?search_query=precision" },
                    { name: "Borg Warner EFR", url: "https://www.borgwarner.com" },
                ]},
                { part: "OS Giken / Tomei Camshafts", vendors: [
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=os+giken" },
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=tomei" },
                    { name: "Kelford Cams", url: "https://kelfordcams.com" },
                ]},
                { part: "AEM Infinity / Haltech Elite ECU", vendors: [
                    { name: "Summit Racing", url: "https://www.summitracing.com/search?q=aem" },
                    { name: "Real Street Performance", url: "https://realstreetperformance.com/search.php?search_query=haltech" },
                    { name: "Link ECU", url: "https://www.linkecu.com" },
                ]},
            ]},
            { area: "Drivetrain", items: [
                { part: "OS Giken Triple-Plate Clutch", vendors: [
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=os+giken" },
                    { name: "Nismo", url: "https://www.nismo.co.jp" },
                    { name: "Exedy Racing", url: "https://www.exedyusa.com" },
                ]},
                { part: "Nismo Reinforced ATTESA Pump", vendors: [
                    { name: "Nismo Heritage Parts", url: "https://www.nismo.co.jp/products/heritage_parts/" },
                    { name: "RHDJapan", url: "https://www.rhdjapan.com" },
                    { name: "Greddy Performance", url: "https://www.greddy.com" },
                ]},
                { part: "HICAS Lock-Out Bar", vendors: [
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=cusco" },
                    { name: "Ikeya Formula", url: "https://www.ikeya-f.co.jp" },
                    { name: "RHDJapan", url: "https://www.rhdjapan.com" },
                ]},
            ]},
            { area: "Suspension", items: [
                { part: "Nismo S-Tune Coilovers", vendors: [
                    { name: "Nismo Heritage Parts", url: "https://www.nismo.co.jp/products/heritage_parts/" },
                    { name: "Tire Rack", url: "https://www.tirerack.com/suspension/index.jsp?brand=KW" },
                    { name: "Tire Rack (Öhlins)", url: "https://www.tirerack.com/suspension/index.jsp?brand=Ohlins" },
                ]},
                { part: "Ikeya Formula Tension Rods", vendors: [
                    { name: "Ikeya Formula", url: "https://www.ikeya-f.co.jp" },
                    { name: "Enjuku Racing", url: "https://www.enjukuracing.com/search/?q=cusco" },
                    { name: "SPL Parts", url: "https://www.splparts.com" },
                ]},
            ]},
            { area: "Brakes", items: [
                { part: "Endless 6-Pot Big Brake Kit", vendors: [
                    { name: "Z1 Motorsports (Endless)", url: "https://www.z1motorsports.com/search.php?search_query=endless" },
                    { name: "Tire Rack (Brembo)", url: "https://www.tirerack.com/brakes/index.jsp?brand=Brembo" },
                    { name: "Essex Parts (AP Racing)", url: "https://essexparts.com" },
                ]},
                { part: "Project Mu HC+800 Pads", vendors: [
                    { name: "Project Mu USA", url: "https://www.projectmuusa.com" },
                    { name: "Z1 Motorsports (Endless)", url: "https://www.z1motorsports.com/search.php?search_query=endless" },
                    { name: "Z1 Motorsports (Winmax)", url: "https://www.z1motorsports.com/search.php?search_query=winmax" },
                ]},
            ]},
            { area: "Aero / Exterior", items: [
                { part: "Nismo Z-Tune Body Kit", vendors: [
                    { name: "Nismo Heritage Parts", url: "https://www.nismo.co.jp/products/heritage_parts/" },
                    { name: "Enjuku Racing (Voltex)", url: "https://www.enjukuracing.com/search/?q=voltex" },
                    { name: "RHDJapan", url: "https://www.rhdjapan.com" },
                ]},
                { part: "Volk TE37 / Rays CE28N Wheels", vendors: [
                    { name: "Mackin Industries (Rays Dist.)", url: "https://www.mackinindustries.com" },
                    { name: "Wheel Pros (Work USA)", url: "https://workwheelsusa.com/find-a-dealer/" },
                    { name: "Enkei USA", url: "https://www.enkei.com" },
                ]},
            ]},
        ],
        interiorMods: [
            "Nismo Multifunction Display + LMGT4 Steering Wheel",
            "Bride Stradia Seats + 4-Point Harnesses",
            "HKS Boost Gauge + Defi Link Meter Cluster",
            "Recaro Pole Position Seat Conversion",
        ],
        knownIssues: [
            {
                title: "RB26 Oil Pump Drive Collar Failure",
                summary: "Stock Sintered Iron Drive Collar Cracks Under Sustained High RPM Or Race Use — A Catastrophic Failure That Destroys The Bottom End.",
                fix: "Upgrade To Tomei N2 Or Reimax Billet Steel Oil Pump With Wider Drive Gear At The First Engine Out.",
                videoUrl: "https://www.youtube.com/results?search_query=rb26+oil+pump+drive+collar+tomei+upgrade",
            },
            {
                title: "ATTESA Pump Whine / Failure",
                summary: "Aging Hydraulic Pumps For The AWD Transfer System Fail, Sending Power Only To The Rear Wheels.",
                fix: "Nismo Heavy-Duty Pump Replacement; Bleed Properly After Install.",
                videoUrl: "https://www.youtube.com/results?search_query=r34+gtr+attesa+pump+replacement+bleed",
            },
            {
                title: "HICAS Steering Wander",
                summary: "Aging Hydraulic Four-Wheel-Steer System Causes Vague Rear-End Feel Above 100 km/h.",
                fix: "Most Builders Install A HICAS Lock-Out Bar To Eliminate The Quirk.",
                videoUrl: "https://www.youtube.com/results?search_query=r34+gtr+hicas+lock+out+bar+install",
            },
        ],
        resources: {
            forums: [
                { label: "GT-R Life", url: "https://www.gtrlife.com" },
                { label: "SkylinesAustralia.com", url: "https://www.skylinesaustralia.com" },
                { label: "r/Skyline", url: "https://www.reddit.com/r/Skyline/" },
            ],
            youtube: [
                { label: "Mighty Car Mods", url: "https://www.youtube.com/@MightyCarMods" },
                { label: "Larry Chen — GT-R Builds", url: "https://www.youtube.com/@larrychenphoto" },
                { label: "Hoonigan — GT-R Features", url: "https://www.youtube.com/@hoonigan" },
            ],
            partsRetailers: [
                { label: "Nismo Heritage Parts", url: "https://www.nismo.co.jp/products/heritage_parts/" },
                { label: "Tomei USA", url: "https://www.tomeiusa.com" },
                { label: "RHDJapan (JDM Imports)", url: "https://www.rhdjapan.com" },
                { label: "HKS USA", url: "https://www.hksusa.com" },
            ],
        },
    },

    // ============ BMW M3 E46 ============
    {
        slug: "bmw-m3-e46",
        name: "BMW M3 E46",
        fullName: "BMW M3 (E46)",
        manufacturer: "BMW",
        type: "car",
        category: "European",
        years: "2000 – 2006",
        engine: "S54B32 · 3.2L Naturally-Aspirated Inline-6",
        horsepower: "338 hp · 269 lb-ft (US Spec)",
        drivetrain: "RWD · 6-Speed Getrag Manual / SMG-II",
        bodyType: "Coupe / Convertible / CSL",
        weight: "1,495 kg",
        zeroToSixty: "4.8 s (Stock)",
        images: [
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/ozsuxi9j_461b993ff1417cc001b57017aeab6f2b.jpg", label: "Hero — Bronze E46 M3, Carbon Splitter, Track-Ready" },
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/zer6n65b_HD-wallpaper-bmw-m3-e46-yellow-sports-coupe-tuning-e46-exterior-understatement-sports-cars-tuning-m3-bmw.jpg", label: "Dakar Yellow Widebody — Front 3/4" },
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/u4q0skrl_79370236_2794668527279299_8503383128310546432_n.jpg", label: "Black Widebody — GT Wing, Hartge Livery" },
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/d8llsuzz_4-L.jpg", label: "S54 Engine Bay — Custom Intake, Strut Brace" },
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/r41tl9lb_BMW-023-Ti-MP-1.webp", label: "Engine Bay — Titanium Hardware Build" },
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/szlbv8g8_bmw-m3-2001-800-44-1.avif", label: "Dakar Yellow — Stock Engine Bay Reference" },
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/hn1jpdtp_Used-2006-BMW-M3-1738126238.jpg", label: "Imola Red — Dead Rear, Quad Exhaust" },
            { url: "https://wallpapercave.com/wp/wp3258067.jpg", label: "Matte Black E46 — Rear With GT Wing" },
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/wvy8k9jz_bmw-m3-gtr-nfs-hd-02.avif", label: "M3 GTR — NFS Most Wanted Tribute" },
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/o9ielpyw_resize_p90193439_highres_m3-gtr-road-version.avif", label: "M3 GTR — Road Version (BMW Press)" },
            { url: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/ckxqkz5m_bmw-m3-gtr-nfs-hd-01.webp", label: "M3 GTR — The Most Wanted Icon" },
        ],
        whyItsIcon:
            "The Last Of The Truly Analog M3s. The S54 Is A Symphony — Individual Throttle Bodies, 8,000 RPM Redline, And A Sound Track That Modern Engineering Cannot Replicate. The CSL Variant, With Its Carbon Roof, Power Bulge Hood, And Cup Rubber, Is Considered By Many To Be The Greatest BMW Of All Time. Built Right, The E46 M3 Is A Generational Driver's Car That Defines The Brand.",
        commonMods: [
            { area: "Engine", items: [
                { part: "MSS54 Software Tune (Epic / Conforti)", vendors: [
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+tune" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+software+tune/" },
                    { name: "Turner Motorsport", url: "https://www.turnermotorsport.com/c-2_3_60-e46-m3-engine-software" },
                ]},
                { part: "Karbonius CSL Carbon Airbox", vendors: [
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/csl+airbox/" },
                    { name: "Turner Motorsport", url: "https://www.turnermotorsport.com/c-2_3-bmw-e46-m3" },
                    { name: "VAC Motorsports", url: "https://www.vacmotorsports.com/index.cfm?category=251" },
                ]},
                { part: "Supersprint Headers + 3\" Catless Exhaust", vendors: [
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+headers+exhaust" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+supersprint/" },
                    { name: "BimmerWorld", url: "https://www.bimmerworld.com/Exhaust/E46-M3/" },
                ]},
                { part: "Schrick / Cat Cams Camshafts", vendors: [
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+camshaft" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+camshaft/" },
                    { name: "VAC Motorsports", url: "https://www.vacmotorsports.com/index.cfm?category=251" },
                ]},
                { part: "ESS VT2-525 Supercharger Kit", vendors: [
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+supercharger/" },
                    { name: "Turner Motorsport", url: "https://www.turnermotorsport.com/c-2_3-bmw-e46-m3" },
                    { name: "Bimmerworld", url: "https://www.bimmerworld.com/E46-M3/" },
                ]},
            ]},
            { area: "Suspension", items: [
                { part: "KW V3 / Ohlins Road & Track Coilovers", vendors: [
                    { name: "Tire Rack", url: "https://www.tirerack.com/suspension/index.jsp?make=BMW&model=M3&year=2003" },
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+coilover" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+coilover/" },
                ]},
                { part: "Vorshlag Camber Plates", vendors: [
                    { name: "Vorshlag (Direct)", url: "https://vorshlag.com/category/bmw-e46-m3/" },
                    { name: "Turner Motorsport", url: "https://www.turnermotorsport.com/c-2_3-bmw-e46-m3" },
                    { name: "BimmerWorld", url: "https://www.bimmerworld.com/E46-M3/Suspension/" },
                ]},
                { part: "Powerflex Bushings (Control Arms, Subframe)", vendors: [
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+powerflex" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+powerflex/" },
                    { name: "RockAuto", url: "https://www.rockauto.com" },
                ]},
                { part: "Whiteline Sway Bars", vendors: [
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+sway+bar" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+sway+bar/" },
                    { name: "Tire Rack", url: "https://www.tirerack.com/suspension/index.jsp?make=BMW&model=M3&year=2003" },
                ]},
            ]},
            { area: "Brakes", items: [
                { part: "BMW Performance / StopTech ST-60 BBK", vendors: [
                    { name: "Tire Rack", url: "https://www.tirerack.com/brakes/index.jsp?make=BMW&model=M3&year=2003" },
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+big+brake" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+brake+kit/" },
                ]},
                { part: "Pagid RS29 Track Pads", vendors: [
                    { name: "Tire Rack", url: "https://www.tirerack.com/brakes/BrakePadsByVehicle.jsp?make=BMW&model=M3&year=2003" },
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+brake+pad" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+brake+pad/" },
                ]},
                { part: "Brake Cooling Ducts", vendors: [
                    { name: "Turner Motorsport", url: "https://www.turnermotorsport.com/c-2_3-bmw-e46-m3" },
                    { name: "BimmerWorld", url: "https://www.bimmerworld.com/E46-M3/Brakes/" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+brake+cooling/" },
                ]},
            ]},
            { area: "Drivetrain", items: [
                { part: "3.91 Final Drive Conversion", vendors: [
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+final+drive" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+differential/" },
                    { name: "Turner Motorsport", url: "https://www.turnermotorsport.com/c-2_3-bmw-e46-m3" },
                ]},
                { part: "OS Giken LSD", vendors: [
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+lsd" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+limited+slip/" },
                    { name: "BimmerWorld", url: "https://www.bimmerworld.com/E46-M3/Drivetrain/" },
                ]},
                { part: "UUC Stage 3 Clutch + Light Flywheel", vendors: [
                    { name: "FCP Euro", url: "https://www.fcpeuro.com/products?q=e46+m3+clutch" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+clutch/" },
                    { name: "Bavarian Autosport", url: "https://www.bavauto.com" },
                ]},
            ]},
            { area: "Aero / Exterior", items: [
                { part: "CSL Front Bumper + Trunk", vendors: [
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+csl/" },
                    { name: "Turner Motorsport", url: "https://www.turnermotorsport.com/c-2_3-bmw-e46-m3" },
                    { name: "BimmerWorld", url: "https://www.bimmerworld.com/E46-M3/" },
                ]},
                { part: "VAC Motorsports GT3 Wing", vendors: [
                    { name: "VAC Motorsports (Direct)", url: "https://www.vacmotorsports.com/index.cfm?category=251" },
                    { name: "ECS Tuning", url: "https://www.ecstuning.com/Search/SiteSearch/e46+m3+wing/" },
                    { name: "Turner Motorsport", url: "https://www.turnermotorsport.com/c-2_3-bmw-e46-m3" },
                ]},
                { part: "BBS LM-R / Style 219 CSL Wheels", vendors: [
                    { name: "Tire Rack", url: "https://www.tirerack.com/wheels/index.jsp?make=BMW&model=M3&year=2003" },
                    { name: "Apex Race Parts", url: "https://www.apexraceparts.com/BMW/E46-M3/" },
                    { name: "Discount Tire Direct", url: "https://www.discounttiredirect.com" },
                ]},
            ]},
        ],
        interiorMods: [
            "CSL-Style Suede / Alcantara Steering Wheel",
            "Recaro Pole Position Or Pro Racer Seats",
            "Schroth 4-Point Harnesses + Harness Bar",
            "Carbon Fiber Trim Replacement",
            "P3 Vent-Mount Boost / AFR Gauge",
        ],
        knownIssues: [
            {
                title: "Rod Bearing Failure (Critical)",
                summary: "The S54 Has Tight Bearing Clearances From The Factory. Beyond ~80,000 Miles The Bearings Begin To Wear And Can Spin Catastrophically Without Warning.",
                fix: "Preventive Rod Bearing Replacement With Updated BMW Or VAC Motorsports Bearings + ARP Rod Bolts. $1,500-$2,500 Job. Most Owners Do This At ~70k Miles.",
                videoUrl: "https://www.youtube.com/results?search_query=e46+m3+s54+rod+bearing+replacement+walkthrough",
            },
            {
                title: "Rear Subframe Cracking",
                summary: "The Rear Subframe Mounting Points On The Chassis Crack Around The Floor Pan. Aggravated By Track Use Or Sticky Tires.",
                fix: "Vincebar Or Vorshlag Subframe Reinforcement Kit Welded To The Chassis. Standard Procedure Before Track Use.",
                videoUrl: "https://www.youtube.com/results?search_query=e46+m3+rear+subframe+reinforcement+vincebar+install",
            },
            {
                title: "VANOS Rattle / Failure",
                summary: "The Variable Valve Timing Unit Develops An Audible Rattle From Worn Internal Bearings And Slack Hub.",
                fix: "Beisan Systems VANOS Rebuild Kit With Updated O-Rings And Hub. DIY Job In A Weekend.",
                videoUrl: "https://www.youtube.com/results?search_query=e46+m3+vanos+rebuild+beisan+systems+diy",
            },
            {
                title: "SMG-II Pump Failure (SMG Cars Only)",
                summary: "The Sequential Manual Gearbox Hydraulic Pump Fails Around 80-100k Miles, Leaving The Car Stranded.",
                fix: "Replace Pump (~$1,800 OEM) Or Convert To 6-Speed Manual With UUC Conversion Kit.",
                videoUrl: "https://www.youtube.com/results?search_query=e46+m3+smg+pump+replacement+manual+conversion",
            },
        ],
        resources: {
            forums: [
                { label: "M3Forum.net", url: "https://www.m3forum.net" },
                { label: "BimmerForums.com", url: "https://www.bimmerforums.com" },
                { label: "r/E46M3", url: "https://www.reddit.com/r/E46M3/" },
            ],
            youtube: [
                { label: "ZeBart — E46 Specialist", url: "https://www.youtube.com/@ZeBart" },
                { label: "ChrisFix — DIY", url: "https://www.youtube.com/@ChrisFix" },
                { label: "Vehicle Virgins — E46 M3 Reviews", url: "https://www.youtube.com/@VehicleVirgins" },
            ],
            partsRetailers: [
                { label: "Turner Motorsport", url: "https://www.turnermotorsport.com" },
                { label: "ECS Tuning", url: "https://www.ecstuning.com" },
                { label: "VAC Motorsports", url: "https://www.vacmotorsports.com" },
                { label: "BimmerWorld", url: "https://www.bimmerworld.com" },
            ],
        },
    },

    // ============ PORSCHE 911 GT3 ============
    {
        slug: "porsche-911-gt3",
        name: "Porsche 911 GT3",
        fullName: "Porsche 911 GT3 (996 / 997 / 991 / 992)",
        manufacturer: "Porsche",
        type: "car",
        category: "European",
        years: "1999 – Present",
        engine: "Mezger / 9A1 Naturally-Aspirated Flat-6",
        horsepower: "360 – 510 hp (Across Generations)",
        drivetrain: "RWD · 6-Speed Manual / 7-Speed PDK",
        bodyType: "2-Door Coupe",
        weight: "1,415 kg (991.2)",
        zeroToSixty: "3.2 s (992 GT3)",
        images: [
            { url: "https://wallpapercave.com/wp/wp2154750.jpg", label: "Hero — Porsche 911 GT3" },
            { url: "https://wallpapercave.com/wp/wp2154758.jpg", label: "Side Profile" },
            { url: "https://wallpapercave.com/wp/wp11137784.jpg", label: "GT3 RS — Cockpit (Interior)" },
            { url: "https://wallpapercave.com/wp/wp11137866.jpg", label: "GT2 RS — Cockpit Detail" },
            { url: "https://wallpapercave.com/wp/wp10617412.jpg", label: "Night Track Stance" },
            { url: "https://wallpapercave.com/wp/wp12346991.jpg", label: "GT3 RS — Track Stance" },
            { url: "https://wallpapercave.com/wp/wp11724991.jpg", label: "GT3 R — Race-Spec Livery" },
            { url: "https://wallpapercave.com/wp/wp4794477.jpg", label: "Guards Red GT3 RS — Daylight Track" },
            { url: "https://wallpapercave.com/wp/wp2154763.jpg", label: "Front Three-Quarter" },
            { url: "https://wallpapercave.com/wp/wp2154775.jpg", label: "Track-Ready Stance" },
            { url: "https://wallpapercave.com/wp/wp11725257.jpg", label: "Rear — 2023 GT3 RS" },
        ],
        whyItsIcon:
            "The Last Pure Naturally-Aspirated Sports Car With An OEM Warranty. The Mezger Engine (996/997.1 GT3) Is An Air-Cooled Race Heart In A Modern Chassis. From The 996 Through The Singer-Adjacent 992 ST, The GT3 Has Remained The Purist's Purist Car — The Reference Standard For How A Road Car Should Feel On A Track Day.",
        commonMods: [
            { area: "Engine", items: [
                { part: "Sport Cats + GT3 Cup Manifold", vendors: [
                    { name: "Pelican Parts (Cargraphic)", url: "https://www.pelicanparts.com/catalog/SuperCat/" },
                    { name: "Revzilla (Akrapovic)", url: "https://www.revzilla.com/akrapovic" },
                    { name: "Suncoast Porsche Parts", url: "https://www.suncoastparts.com" },
                ]},
                { part: "Akrapovic Titanium Slip-On Exhaust", vendors: [
                    { name: "Revzilla (Akrapovic)", url: "https://www.revzilla.com/akrapovic" },
                    { name: "Pelican Parts (Cargraphic)", url: "https://www.pelicanparts.com/catalog/SuperCat/" },
                    { name: "Tubi Style", url: "https://www.tubistyle.com" },
                ]},
                { part: "Cup Camshafts (996/997 Mezger)", vendors: [
                    { name: "Pelican Parts (Cargraphic)", url: "https://www.pelicanparts.com/catalog/SuperCat/" },
                    { name: "Suncoast Porsche Parts", url: "https://www.suncoastparts.com" },
                    { name: "RUF Automobile", url: "https://www.ruf-automobile.de" },
                ]},
                { part: "Cobb Accessport / Reflashed DME", vendors: [
                    { name: "Cobb Tuning (Direct)", url: "https://www.cobbtuning.com/collections/all" },
                    { name: "Softronic (Direct)", url: "https://www.softronic.us" },
                    { name: "Suncoast Porsche Parts", url: "https://www.suncoastparts.com" },
                ]},
            ]},
            { area: "Suspension", items: [
                { part: "KW Clubsport 3-Way Coilovers", vendors: [
                    { name: "Tire Rack", url: "https://www.tirerack.com/suspension/index.jsp?brand=KW" },
                    { name: "Tire Rack (Öhlins)", url: "https://www.tirerack.com/suspension/index.jsp?brand=Ohlins" },
                    { name: "JRZ Suspension", url: "https://www.jrzsuspension.com" },
                ]},
                { part: "Manthey Racing 'MR' Suspension Package", vendors: [
                    { name: "Suncoast Porsche Parts", url: "https://www.suncoastparts.com" },
                    { name: "Tarett Engineering", url: "https://www.tarett.com" },
                    { name: "Bilstein", url: "https://www.bilstein.com" },
                ]},
                { part: "Tarett Engineering Drop Links + Endlinks", vendors: [
                    { name: "Tarett Engineering", url: "https://www.tarett.com" },
                    { name: "GMG Racing", url: "https://www.gmgracing.com" },
                    { name: "Rebellion Forge", url: "https://rebellionforge.com" },
                ]},
            ]},
            { area: "Aero", items: [
                { part: "Manthey MR Carbon Front Lip", vendors: [
                    { name: "Suncoast Porsche Parts", url: "https://www.suncoastparts.com" },
                    { name: "TechArt", url: "https://www.techart.de" },
                    { name: "Vorsteiner", url: "https://www.vorsteiner.com" },
                ]},
                { part: "Cup Wing Endplates", vendors: [
                    { name: "Champion Motorsports", url: "https://www.championmotorsport.com" },
                    { name: "Suncoast Porsche Parts", url: "https://www.suncoastparts.com" },
                    { name: "BBI Autosport", url: "https://bbiautosport.com" },
                ]},
            ]},
            { area: "Brakes", items: [
                { part: "PCCB Carbon-Ceramic Refresh", vendors: [
                    { name: "Porsche Classic Parts", url: "https://classicparts.porsche.com" },
                    { name: "Suncoast Porsche Parts", url: "https://www.suncoastparts.com" },
                    { name: "Pelican Parts", url: "https://www.pelicanparts.com" },
                ]},
                { part: "Pagid RSL29 Track Pads", vendors: [
                    { name: "Essex Parts (Pagid)", url: "https://essexparts.com" },
                    { name: "Z1 Motorsports (Endless)", url: "https://www.z1motorsports.com/search.php?search_query=endless" },
                    { name: "Carbotech Brakes", url: "https://carbotechbrakes.com" },
                ]},
            ]},
            { area: "Wheels", items: [
                { part: "BBS Magnesium GT3 Cup Wheels", vendors: [
                    { name: "Tire Rack (BBS)", url: "https://www.tirerack.com/wheels/index.jsp?brand=BBS" },
                    { name: "Tire Rack (Forgeline)", url: "https://www.tirerack.com/wheels/index.jsp?brand=Forgeline" },
                    { name: "Apex Race Parts", url: "https://www.apexraceparts.com" },
                ]},
                { part: "Forgeline 3-Piece Custom", vendors: [
                    { name: "Tire Rack (Forgeline)", url: "https://www.tirerack.com/wheels/index.jsp?brand=Forgeline" },
                    { name: "Tire Rack (HRE)", url: "https://www.tirerack.com/wheels/index.jsp?brand=HRE" },
                    { name: "Vorsteiner", url: "https://www.vorsteiner.com" },
                ]},
            ]},
        ],
        interiorMods: [
            "Carbon-Backed Sport Bucket Seats (Recaro Or Sparco)",
            "Schroth 6-Point Harness With Harness Bar / Cage",
            "Alcantara Steering Wheel Retrim (911 / Singer Style)",
            "Half / Full Roll Cage (Brey-Krause Or Custom)",
        ],
        knownIssues: [
            {
                title: "IMS Bearing Failure (Non-Mezger Engines Only)",
                summary: "The Mezger GT3 Engine Is IMS-Safe — But Non-GT3 996/997 Carrera Engines Suffer Intermediate Shaft Bearing Failures. Confirm Mezger Build Plate Before Buying.",
                fix: "Verify Engine Code (M96.76 = Mezger GT3, Safe). If Buying A Carrera For GT3 Swap, LN Engineering IMS Solution Kit.",
                videoUrl: "https://www.youtube.com/results?search_query=porsche+996+ims+bearing+ln+engineering+install",
            },
            {
                title: "Camshaft Tensioner Tick / RMS Weep",
                summary: "997.1 Engines Exhibit Camshaft Tensioner Ticking And Rear Main Seal Weeping With Age.",
                fix: "Updated Tensioner Pads And RMS Replacement During Clutch Service.",
                videoUrl: "https://www.youtube.com/results?search_query=porsche+997+camshaft+tensioner+pad+rms+replacement",
            },
            {
                title: "Coffin Arms / Bushings Wear",
                summary: "Front Control Arm Bushings Develop Looseness Over Track Use, Causing Steering Vagueness.",
                fix: "Tarett Engineering Spherical Monoball Conversion Or OEM Refresh.",
                videoUrl: "https://www.youtube.com/results?search_query=porsche+911+gt3+front+control+arm+monoball+tarett",
            },
        ],
        resources: {
            forums: [
                { label: "Rennlist.com", url: "https://rennlist.com" },
                { label: "6Speed Online", url: "https://www.6speedonline.com" },
                { label: "r/Porsche", url: "https://www.reddit.com/r/Porsche/" },
            ],
            youtube: [
                { label: "Manthey Racing", url: "https://www.youtube.com/@MantheyRacingOfficial" },
                { label: "Carfection — GT3 Reviews", url: "https://www.youtube.com/@Carfection" },
                { label: "Henry Catchpole / Hagerty GT3", url: "https://www.youtube.com/@Hagerty" },
            ],
            partsRetailers: [
                { label: "Suncoast Parts", url: "https://www.suncoastparts.com" },
                { label: "Pelican Parts", url: "https://www.pelicanparts.com" },
                { label: "Manthey Racing Performance Parts", url: "https://www.manthey-racing.de" },
                { label: "Tarett Engineering", url: "https://www.tarett.com" },
            ],
        },
    },

    // ============ FORD MUSTANG SHELBY GT500 ============
    {
        slug: "mustang-shelby-gt500",
        name: "Mustang Shelby GT500",
        fullName: "Ford Mustang Shelby GT500 (2020+)",
        manufacturer: "Ford",
        type: "car",
        category: "American Muscle",
        years: "2007 – Present",
        engine: "5.2L Predator Supercharged V8 (Current Gen)",
        horsepower: "760 hp · 625 lb-ft (S550 GT500)",
        drivetrain: "RWD · 7-Speed Tremec Dual-Clutch",
        bodyType: "2-Door Coupe",
        weight: "1,860 kg",
        zeroToSixty: "3.3 s (Stock)",
        images: [
            { url: "https://wallpapercave.com/wp/wp10445202.jpg", label: "Hero — 2022 Mustang Shelby GT500" },
            { url: "https://wallpapercave.com/wp/wp10418084.jpg", label: "Rear — Quad Exhaust, Cobra Badge" },
            { url: "https://wallpapercave.com/wp/wp9356814.jpg", label: "Front Three-Quarter" },
            { url: "https://wallpapercave.com/wp/wp5103466.jpg", label: "Black GT500" },
            { url: "https://wallpapercave.com/wp/wp4697720.jpg", label: "Editorial Shoot" },
            { url: "https://wallpapercave.com/wp/wp12248132.jpg", label: "GT500 Track-Spec" },
            { url: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/20_Ford_Mustang_Shelby_GT500_Hennessey_HPE1000.jpg/3840px-20_Ford_Mustang_Shelby_GT500_Hennessey_HPE1000.jpg", label: "Hennessey HPE1000 Predator V8 Build" },
            { url: "https://wallpapercave.com/wp/wp14839027.jpg", label: "1967 GT500 — Heritage" },
            { url: "https://wallpapercave.com/wp/wp1859015.jpg", label: "Carroll Shelby Original" },
        ],
        whyItsIcon:
            "The Most Powerful Production Ford Ever Built. Carroll Shelby's Spirit Lives In A Hand-Assembled Predator V8 With A 2.65L TVS Supercharger Sitting On Top. The GT500 Is The Working-Class Hypercar — Sub-3.5-Second 0-60 Times For The Price Of A German Mid-Tier Sedan, And It Goes 180+ Mph In A Straight Line All Day Long.",
        commonMods: [
            { area: "Engine", items: [
                { part: "Smaller Supercharger Pulley Upgrade", vendors: [
                    { name: "VMP Performance", url: "https://www.vmpperformance.com" },
                    { name: "Lund Racing", url: "https://lundracing.com" },
                    { name: "Steeda Autosports", url: "https://www.steeda.com" },
                ]},
                { part: "Injector Dynamics 1700cc Injectors", vendors: [
                    { name: "Summit Racing", url: "https://www.summitracing.com/search?q=injector+dynamics" },
                    { name: "Fuel Injector Clinic", url: "https://www.fuelinjectorclinic.com" },
                    { name: "DeatschWerks", url: "https://www.deatschwerks.com" },
                ]},
                { part: "Cobb Accessport / Lund E85 Tune", vendors: [
                    { name: "Cobb Tuning (Direct)", url: "https://www.cobbtuning.com/collections/all" },
                    { name: "Lund Racing", url: "https://lundracing.com" },
                    { name: "Palm Beach Dyno", url: "https://palmbeachdyno.com" },
                ]},
                { part: "Mishimoto Heat Exchanger Upgrade", vendors: [
                    { name: "Summit Racing (Mishimoto)", url: "https://www.summitracing.com/search?q=mishimoto" },
                    { name: "AmericanMuscle (Whipple)", url: "https://www.americanmuscle.com/whipple-supercharger.html" },
                    { name: "VMP Performance", url: "https://www.vmpperformance.com" },
                ]},
                { part: "Whipple 3.8L Supercharger Conversion", vendors: [
                    { name: "AmericanMuscle (Whipple)", url: "https://www.americanmuscle.com/whipple-supercharger.html" },
                    { name: "VMP Performance", url: "https://www.vmpperformance.com" },
                    { name: "Steeda Autosports", url: "https://www.steeda.com" },
                ]},
            ]},
            { area: "Suspension", items: [
                { part: "BMR Lowering Springs", vendors: [
                    { name: "AmericanMuscle (BMR)", url: "https://www.americanmuscle.com/bmr-suspension.html" },
                    { name: "Steeda Autosports", url: "https://www.steeda.com" },
                    { name: "Tire Rack (Eibach)", url: "https://www.tirerack.com/suspension/index.jsp?brand=Eibach" },
                ]},
                { part: "MagneRide Tune (Steeda / SVE)", vendors: [
                    { name: "Steeda Autosports", url: "https://www.steeda.com" },
                    { name: "SVE / LMR", url: "https://www.latemodelrestoration.com" },
                    { name: "AmericanMuscle", url: "https://www.americanmuscle.com" },
                ]},
                { part: "Solid Subframe + Diff Bushings", vendors: [
                    { name: "Steeda Autosports", url: "https://www.steeda.com" },
                    { name: "AmericanMuscle (BMR)", url: "https://www.americanmuscle.com/bmr-suspension.html" },
                    { name: "Maximum Motorsports", url: "https://maximummotorsports.com" },
                ]},
            ]},
            { area: "Drivetrain", items: [
                { part: "3.73 / 4.10 Final Drive Conversion", vendors: [
                    { name: "AmericanMuscle (Ford Performance)", url: "https://www.americanmuscle.com/ford-performance.html" },
                    { name: "AmericanMuscle", url: "https://www.americanmuscle.com" },
                    { name: "Steeda Autosports", url: "https://www.steeda.com" },
                ]},
                { part: "Differential Cooler", vendors: [
                    { name: "AmericanMuscle (Ford Performance)", url: "https://www.americanmuscle.com/ford-performance.html" },
                    { name: "Summit Racing (Mishimoto)", url: "https://www.summitracing.com/search?q=mishimoto" },
                    { name: "Setrab Coolers", url: "https://www.setrab.com" },
                ]},
                { part: "Driveshaft Shop Halfshafts", vendors: [
                    { name: "The Driveshaft Shop", url: "https://www.driveshaftshop.com" },
                    { name: "American Racing Solutions", url: "https://americanracingsolutions.com" },
                    { name: "GForce Engineering", url: "https://www.gforce1320.com" },
                ]},
            ]},
            { area: "Brakes", items: [
                { part: "StopTech ST-60 Drilled Rotors", vendors: [
                    { name: "Tire Rack (StopTech)", url: "https://www.tirerack.com/brakes/index.jsp?brand=StopTech" },
                    { name: "Tire Rack (Brembo)", url: "https://www.tirerack.com/brakes/index.jsp?brand=Brembo" },
                    { name: "Wilwood", url: "https://www.wilwood.com" },
                ]},
                { part: "Carbon-Ceramic Track Pads", vendors: [
                    { name: "Essex Parts (Pagid)", url: "https://essexparts.com" },
                    { name: "Carbotech Brakes", url: "https://carbotechbrakes.com" },
                    { name: "Summit Racing (Hawk)", url: "https://www.summitracing.com/search?q=hawk+pads" },
                ]},
            ]},
            { area: "Aero / Exterior", items: [
                { part: "Carbon Fiber Track Pack Hood", vendors: [
                    { name: "AmericanMuscle (Ford Performance)", url: "https://www.americanmuscle.com/ford-performance.html" },
                    { name: "AmericanMuscle (Anderson)", url: "https://www.americanmuscle.com/anderson-composites.html" },
                    { name: "TruCarbon", url: "https://www.trucarbon.com" },
                ]},
                { part: "Borla / MagnaFlow Active Exhaust", vendors: [
                    { name: "AmericanMuscle (Borla)", url: "https://www.americanmuscle.com/borla-exhaust.html" },
                    { name: "Summit Racing (MagnaFlow)", url: "https://www.summitracing.com/search?q=magnaflow" },
                    { name: "Roush Performance", url: "https://www.roushperformance.com" },
                ]},
                { part: "Roush / Shelby Gauntlet Wheels", vendors: [
                    { name: "Roush Performance", url: "https://www.roushperformance.com" },
                    { name: "Shelby American", url: "https://www.shelby.com" },
                    { name: "American Racing Wheels", url: "https://www.americanracing.com" },
                ]},
            ]},
        ],
        interiorMods: [
            "Recaro Sport Seats (OEM Available Option)",
            "Alcantara Wrapped Shift Knob + Steering Wheel",
            "AEM CD-5 Carbon Digital Dash",
            "Diamond-Stitched Leather Reupholstery (Local Trim Shops)",
        ],
        knownIssues: [
            {
                title: "Supercharger Snout Bearing Failure (Pre-2020)",
                summary: "Earlier Eaton TVS Units Suffered Snout Bearing Wear, Causing Whining And Eventual Failure With Aggressive Tunes.",
                fix: "VMP Performance Snout Rebuild Kit Or Whipple Conversion. Use Premium Oil Service Intervals.",
                videoUrl: "https://www.youtube.com/results?search_query=mustang+gt500+supercharger+snout+rebuild+vmp",
            },
            {
                title: "Heat Soak / Power Drop On Hot Days",
                summary: "Stock Heat Exchanger Cannot Keep IATs Down On Repeat Pulls In 100°F+ Climates (Like Riyadh).",
                fix: "Larger Mishimoto Heat Exchanger + Dedicated Fan Upgrade + Cooling Reservoir Tank.",
                videoUrl: "https://www.youtube.com/results?search_query=gt500+predator+heat+exchanger+upgrade+mishimoto",
            },
            {
                title: "Halfshaft Failure Under Launch",
                summary: "Stock Driveshafts Twist Or Fail Under Aggressive Launches At Higher Boost Levels.",
                fix: "Upgraded Halfshafts From The Driveshaft Shop Or American Racing Solutions.",
                videoUrl: "https://www.youtube.com/results?search_query=mustang+gt500+halfshaft+upgrade+driveshaft+shop",
            },
        ],
        resources: {
            forums: [
                { label: "Mustang7G.com (S550)", url: "https://www.mustang7g.com" },
                { label: "SVTPerformance", url: "https://www.svtperformance.com" },
                { label: "r/Mustang", url: "https://www.reddit.com/r/Mustang/" },
            ],
            youtube: [
                { label: "Lund Racing", url: "https://www.youtube.com/@LundRacing" },
                { label: "MotorTrend — GT500 Reviews", url: "https://www.youtube.com/@MotorTrendChannel" },
                { label: "ThatDudeInBlue", url: "https://www.youtube.com/@ThatDudeInBlue" },
            ],
            partsRetailers: [
                { label: "Steeda Autosports", url: "https://www.steeda.com" },
                { label: "AmericanMuscle.com", url: "https://www.americanmuscle.com" },
                { label: "VMP Performance", url: "https://www.vmpperformance.com" },
                { label: "Whipple Superchargers", url: "https://www.whipplesuperchargers.com" },
            ],
        },
    },

    // ============ DUCATI PANIGALE V4 ============
    {
        slug: "ducati-panigale-v4",
        name: "Ducati Panigale V4",
        fullName: "Ducati Panigale V4 / V4 S / V4 R",
        manufacturer: "Ducati",
        type: "motorcycle",
        category: "Superbike",
        years: "2018 – Present",
        engine: "Desmosedici Stradale 1,103 cc · 90° V4",
        horsepower: "215 hp (V4 / V4 S) · 240 hp (V4 R Track)",
        drivetrain: "Chain · 6-Speed Quickshifter EVO",
        bodyType: "Superbike",
        weight: "175 kg (Dry)",
        zeroToSixty: "2.6 s",
        images: [
            { url: "https://wallpapercave.com/wp/wp2402111.jpg", label: "Hero — V4 Speciale" },
            { url: "https://wallpapercave.com/wp/wp3754446.jpg", label: "Speciale Editorial" },
            { url: "https://wallpapercave.com/wp/wp3754439.jpg", label: "V4 S Racing" },
            { url: "https://wallpapercave.com/wp/wp3754461.jpg", label: "V4 S — Profile" },
            { url: "https://wallpapercave.com/wp/wp3754485.jpg", label: "V4 S — Studio" },
            { url: "https://wallpapercave.com/wp/wp3754512.jpg", label: "V4 — Detail" },
            { url: "https://wallpapercave.com/wp/wp3754442.jpg", label: "Details Shoot" },
            { url: "https://wallpapercave.com/wp/wp3754575.jpg", label: "Panigale R Final Edition" },
            { url: "https://wallpapercave.com/wp/wp3754582.jpg", label: "Cockpit Detail" },
        ],
        whyItsIcon:
            "MotoGP Engineering In A Road-Legal Chassis. The Desmosedici Stradale Engine Is Borrowed Directly From Ducati's GP Programme — A 90° V4 Crank, Counter-Rotating Crankshaft, And Desmodromic Valves. From The Side, The V4 R Is Indistinguishable From What Pecco Bagnaia Rides On Sunday. There Is No More Authentic Superbike On Sale Today.",
        commonMods: [
            { area: "Exhaust / Engine", items: [
                { part: "Akrapovic Full Titanium Race System", vendors: [
                    { name: "Revzilla (Akrapovic)", url: "https://www.revzilla.com/akrapovic" },
                    { name: "SC-Project", url: "https://www.sc-project.com" },
                    { name: "Arrow Special Parts", url: "https://www.arrow.it" },
                ]},
                { part: "Termignoni 4-2-1-2 Race Exhaust", vendors: [
                    { name: "Motowheels (Termignoni)", url: "https://www.motowheels.com/search?q=termignoni" },
                    { name: "Ducati Performance", url: "https://shop.ducati.com" },
                    { name: "Motowheels", url: "https://www.motowheels.com" },
                ]},
                { part: "Up-Map Tuning Device + Race ECU", vendors: [
                    { name: "Motowheels (Up-Map)", url: "https://www.motowheels.com/search?q=upmap" },
                    { name: "Ducati Performance", url: "https://shop.ducati.com" },
                    { name: "Motorrad-Schmitt", url: "https://www.motorrad-schmitt.de" },
                ]},
                { part: "DNA Racing Air Filter", vendors: [
                    { name: "DNA Filters", url: "https://www.dnafilters.com" },
                    { name: "BMC Air Filters", url: "https://www.bmcairfilters.com" },
                    { name: "Sprint Filter", url: "https://www.sprintfilter.com" },
                ]},
            ]},
            { area: "Suspension", items: [
                { part: "Ohlins NIX EVO Fork Cartridges", vendors: [
                    { name: "Tire Rack (Öhlins)", url: "https://www.tirerack.com/suspension/index.jsp?brand=Ohlins" },
                    { name: "K-Tech Suspension", url: "https://k-techsuspension.com" },
                    { name: "Andreani Group", url: "https://www.andreanigroup.com" },
                ]},
                { part: "Ohlins TTX36 Rear Shock", vendors: [
                    { name: "Tire Rack (Öhlins)", url: "https://www.tirerack.com/suspension/index.jsp?brand=Ohlins" },
                    { name: "K-Tech Suspension", url: "https://k-techsuspension.com" },
                    { name: "Bitubo", url: "https://www.bitubo.com" },
                ]},
            ]},
            { area: "Aero / Bodywork", items: [
                { part: "V4 R Carbon Winglet Kit", vendors: [
                    { name: "Ducati Performance", url: "https://shop.ducati.com" },
                    { name: "Strauss Carbon", url: "https://strausscarbon.com" },
                    { name: "Motowheels (Carbonin)", url: "https://www.motowheels.com/search?q=carbonin" },
                ]},
                { part: "Strauss Carbon Race Bodywork", vendors: [
                    { name: "Strauss Carbon", url: "https://strausscarbon.com" },
                    { name: "Motowheels (Carbonin)", url: "https://www.motowheels.com/search?q=carbonin" },
                    { name: "Ilmberger Carbon", url: "https://www.ilmberger-carbon.com" },
                ]},
            ]},
            { area: "Wheels / Brakes", items: [
                { part: "BST Carbon Fiber Wheels", vendors: [
                    { name: "Motowheels (BST)", url: "https://www.motowheels.com/search?q=bst" },
                    { name: "AMS Ducati (Rotobox)", url: "https://www.amsducati.com" },
                    { name: "Marchesini Wheels", url: "https://www.marchesini.com" },
                ]},
                { part: "Brembo Stylema R / GP4-RS Calipers", vendors: [
                    { name: "Tire Rack (Brembo)", url: "https://www.tirerack.com/brakes/index.jsp?brand=Brembo" },
                    { name: "Ducati Performance", url: "https://shop.ducati.com" },
                    { name: "Motowheels", url: "https://www.motowheels.com" },
                ]},
            ]},
            { area: "Electronics", items: [
                { part: "AiM Solo 2 DL GPS Lap Timer", vendors: [
                    { name: "AiM Sports", url: "https://www.aim-sportline.com" },
                    { name: "Starlane", url: "https://www.starlane.com" },
                    { name: "Lifeline Fire", url: "https://www.lifeline-fire.co.uk" },
                ]},
                { part: "Antigravity Lithium Battery", vendors: [
                    { name: "Revzilla (Antigravity)", url: "https://www.revzilla.com/antigravity-batteries" },
                    { name: "Shorai Power Sports", url: "https://shoraipower.com" },
                    { name: "EarthX Batteries", url: "https://earthxbatteries.com" },
                ]},
            ]},
        ],
        interiorMods: [
            "Race Seat Foam (Kit Available From Ducati Performance)",
            "Rizoma Bar-Ends + Levers",
            "Carbon Dashboard Surround",
            "Number Plate Holder / Fender Eliminator",
        ],
        knownIssues: [
            {
                title: "Excessive Engine Heat (Pre-2020)",
                summary: "First-Gen Panigale V4 Suffered From Heat Radiating To Rider's Right Thigh, Especially In Traffic.",
                fix: "2020+ Models Re-Engineered Routing. For Earlier Bikes: Aftermarket Heat Shield (Carbonin) + Header Wrap.",
                videoUrl: "https://www.youtube.com/results?search_query=ducati+panigale+v4+heat+shield+install+carbonin",
            },
            {
                title: "Desmodromic Valve Service Cost",
                summary: "The Desmo Valve Train Requires Specialist Adjustment Every ~15,000 Miles And Is Not A DIY Job.",
                fix: "Budget €1,500-€2,500 At A Certified Ducati Service Centre. Riyadh Riders Should Confirm Service Availability Before Purchase.",
                videoUrl: "https://www.youtube.com/results?search_query=ducati+desmodromic+valve+service+walkthrough",
            },
            {
                title: "Quickshifter Sensor Failure",
                summary: "The Bidirectional Quickshifter Sensor Has Failed On Some Bikes Under Heavy Track Use.",
                fix: "Updated Bosch Sensor Available Under Recall On Some VINs; Otherwise A 20-Minute Dealer Replacement.",
                videoUrl: "https://www.youtube.com/results?search_query=ducati+panigale+v4+quickshifter+sensor+replacement",
            },
        ],
        resources: {
            forums: [
                { label: "Ducati.ms — The Definitive Forum", url: "https://www.ducati.ms" },
                { label: "DucatiForum.com", url: "https://www.ducatiforum.com" },
                { label: "r/Ducati", url: "https://www.reddit.com/r/Ducati/" },
            ],
            youtube: [
                { label: "Yammie Noob", url: "https://www.youtube.com/@YammieNoob" },
                { label: "MotorcyclistOnline", url: "https://www.youtube.com/@motorcyclistonline" },
                { label: "Bike World — V4 R Reviews", url: "https://www.youtube.com/@BikeWorld" },
            ],
            partsRetailers: [
                { label: "Motowheels (Ducati Specialist)", url: "https://www.motowheels.com" },
                { label: "AMS-Ducati Performance", url: "https://www.amsducati.com" },
                { label: "Revzilla", url: "https://www.revzilla.com" },
                { label: "Ducati Performance Shop", url: "https://shop.ducati.com" },
            ],
        },
    },

    // ============ STUB ENTRIES (Marquee items, basic detail page) ============
    // Toyota (5 more)
    { slug: "supra-mk5-a90", name: "Toyota Supra MK5", manufacturer: "Toyota", type: "car" },
    { slug: "toyota-ae86", name: "Toyota AE86 Corolla", manufacturer: "Toyota", type: "car" },
    { slug: "toyota-mr2-sw20", name: "Toyota MR2 (SW20)", manufacturer: "Toyota", type: "car" },
    { slug: "toyota-chaser-jzx100", name: "Toyota Chaser JZX100", manufacturer: "Toyota", type: "car" },
    { slug: "toyota-celica-gtfour", name: "Toyota Celica GT-Four", manufacturer: "Toyota", type: "car" },
    // Nissan (5 more)
    { slug: "skyline-gtr-r32", name: "Nissan Skyline GT-R R32", manufacturer: "Nissan", type: "car" },
    { slug: "skyline-gtr-r33", name: "Nissan Skyline GT-R R33", manufacturer: "Nissan", type: "car" },
    { slug: "gtr-r35", name: "Nissan GT-R R35", manufacturer: "Nissan", type: "car" },
    { slug: "silvia-s15", name: "Nissan Silvia S15", manufacturer: "Nissan", type: "car" },
    { slug: "nissan-240sx-s14", name: "Nissan 240SX (S14)", manufacturer: "Nissan", type: "car" },
    // Honda (6)
    { slug: "civic-type-r-ek9", name: "Honda Civic Type R (EK9)", manufacturer: "Honda", type: "car" },
    { slug: "civic-type-r-fk8", name: "Honda Civic Type R (FK8)", manufacturer: "Honda", type: "car" },
    { slug: "honda-s2000", name: "Honda S2000", manufacturer: "Honda", type: "car" },
    { slug: "honda-nsx-na1", name: "Honda NSX (NA1)", manufacturer: "Honda", type: "car" },
    { slug: "honda-integra-type-r-dc2", name: "Honda Integra Type R (DC2)", manufacturer: "Honda", type: "car" },
    { slug: "honda-prelude", name: "Honda Prelude", manufacturer: "Honda", type: "car" },
    // Mazda (6)
    { slug: "mazda-rx7-fd3s", name: "Mazda RX-7 FD3S", manufacturer: "Mazda", type: "car" },
    { slug: "mazda-rx8", name: "Mazda RX-8", manufacturer: "Mazda", type: "car" },
    { slug: "mazda-miata-na", name: "Mazda MX-5 Miata NA", manufacturer: "Mazda", type: "car" },
    { slug: "mazda-mx5-nd", name: "Mazda MX-5 ND", manufacturer: "Mazda", type: "car" },
    { slug: "mazdaspeed-3", name: "Mazdaspeed 3", manufacturer: "Mazda", type: "car" },
    { slug: "mazda-rx3", name: "Mazda RX-3", manufacturer: "Mazda", type: "car" },
    // Mitsubishi (6)
    { slug: "lancer-evo-ix", name: "Mitsubishi Lancer Evo IX", manufacturer: "Mitsubishi", type: "car" },
    { slug: "lancer-evo-x", name: "Mitsubishi Lancer Evo X", manufacturer: "Mitsubishi", type: "car" },
    { slug: "mitsubishi-3000gt-vr4", name: "Mitsubishi 3000GT VR-4", manufacturer: "Mitsubishi", type: "car" },
    { slug: "mitsubishi-eclipse-gsx", name: "Mitsubishi Eclipse GSX", manufacturer: "Mitsubishi", type: "car" },
    { slug: "mitsubishi-galant-vr4", name: "Mitsubishi Galant VR-4", manufacturer: "Mitsubishi", type: "car" },
    { slug: "mitsubishi-fto", name: "Mitsubishi FTO", manufacturer: "Mitsubishi", type: "car" },
    // Subaru (6)
    { slug: "subaru-22b-sti", name: "Subaru Impreza 22B STI", manufacturer: "Subaru", type: "car" },
    { slug: "subaru-gc8-sti", name: "Subaru Impreza WRX STI (GC8)", manufacturer: "Subaru", type: "car" },
    { slug: "subaru-wrx-sti-hawkeye", name: "Subaru WRX STI Hawkeye", manufacturer: "Subaru", type: "car" },
    { slug: "subaru-brz", name: "Subaru BRZ", manufacturer: "Subaru", type: "car" },
    { slug: "subaru-forester-xt", name: "Subaru Forester XT", manufacturer: "Subaru", type: "car" },
    { slug: "subaru-legacy-gt", name: "Subaru Legacy GT", manufacturer: "Subaru", type: "car" },
    // BMW (5 more)
    { slug: "bmw-m3-e30", name: "BMW M3 E30", manufacturer: "BMW", type: "car" },
    { slug: "bmw-m3-e92", name: "BMW M3 E92", manufacturer: "BMW", type: "car" },
    { slug: "bmw-m3-f80-g80", name: "BMW M3 F80 / G80", manufacturer: "BMW", type: "car" },
    { slug: "bmw-m5-e39", name: "BMW M5 E39", manufacturer: "BMW", type: "car" },
    { slug: "bmw-m5-f90", name: "BMW M5 F90", manufacturer: "BMW", type: "car" },
    // Mercedes-AMG (6)
    { slug: "mercedes-amg-c63", name: "Mercedes-AMG C63", manufacturer: "Mercedes-AMG", type: "car" },
    { slug: "mercedes-amg-e63", name: "Mercedes-AMG E63", manufacturer: "Mercedes-AMG", type: "car" },
    { slug: "mercedes-amg-g63", name: "Mercedes-AMG G63", manufacturer: "Mercedes-AMG", type: "car" },
    { slug: "mercedes-amg-sls", name: "Mercedes-AMG SLS", manufacturer: "Mercedes-AMG", type: "car" },
    { slug: "mercedes-amg-gtr", name: "Mercedes-AMG GT R", manufacturer: "Mercedes-AMG", type: "car" },
    { slug: "mercedes-amg-s63", name: "Mercedes-AMG S63", manufacturer: "Mercedes-AMG", type: "car" },
    // Audi (6)
    { slug: "audi-rs6", name: "Audi RS6 Avant", manufacturer: "Audi", type: "car" },
    { slug: "audi-rs7", name: "Audi RS7", manufacturer: "Audi", type: "car" },
    { slug: "audi-r8-v10", name: "Audi R8 V10", manufacturer: "Audi", type: "car" },
    { slug: "audi-s4-b5", name: "Audi S4 B5", manufacturer: "Audi", type: "car" },
    { slug: "audi-quattro-ur", name: "Audi Quattro UR", manufacturer: "Audi", type: "car" },
    { slug: "audi-tt-rs", name: "Audi TT RS", manufacturer: "Audi", type: "car" },
    // Porsche (5 more)
    { slug: "porsche-911-turbo-930", name: "Porsche 911 Turbo (930)", manufacturer: "Porsche", type: "car" },
    { slug: "porsche-cayman-gt4", name: "Porsche Cayman GT4", manufacturer: "Porsche", type: "car" },
    { slug: "porsche-944-turbo", name: "Porsche 944 Turbo", manufacturer: "Porsche", type: "car" },
    { slug: "porsche-996-gt3-rs", name: "Porsche 996 GT3 RS", manufacturer: "Porsche", type: "car" },
    { slug: "porsche-boxster-spyder", name: "Porsche Boxster Spyder", manufacturer: "Porsche", type: "car" },
    // VW (6)
    { slug: "vw-golf-r-mk7", name: "VW Mk7 Golf R", manufacturer: "Volkswagen", type: "car" },
    { slug: "vw-gti-mk5", name: "VW Mk5 Golf GTI", manufacturer: "Volkswagen", type: "car" },
    { slug: "vw-gti-mk7", name: "VW Mk7 GTI", manufacturer: "Volkswagen", type: "car" },
    { slug: "vw-corrado-vr6", name: "VW Corrado VR6", manufacturer: "Volkswagen", type: "car" },
    { slug: "vw-mk1-gti", name: "VW Mk1 GTI", manufacturer: "Volkswagen", type: "car" },
    { slug: "vw-scirocco-r", name: "VW Scirocco R", manufacturer: "Volkswagen", type: "car" },
    // Ford (5 more)
    { slug: "ford-gt", name: "Ford GT", manufacturer: "Ford", type: "car" },
    { slug: "ford-focus-rs-mk3", name: "Ford Focus RS (Mk3)", manufacturer: "Ford", type: "car" },
    { slug: "ford-rs200", name: "Ford RS200", manufacturer: "Ford", type: "car" },
    { slug: "ford-sierra-cosworth", name: "Ford Sierra Cosworth", manufacturer: "Ford", type: "car" },
    { slug: "ford-escort-cosworth", name: "Ford Escort Cosworth", manufacturer: "Ford", type: "car" },
    // Chevrolet (6)
    { slug: "chevy-corvette-c8", name: "Chevrolet Corvette C8", manufacturer: "Chevrolet", type: "car" },
    { slug: "chevy-corvette-zr1-c7", name: "Chevrolet Corvette ZR1 (C7)", manufacturer: "Chevrolet", type: "car" },
    { slug: "chevy-camaro-zl1", name: "Chevrolet Camaro ZL1", manufacturer: "Chevrolet", type: "car" },
    { slug: "chevy-camaro-ss", name: "Chevrolet Camaro SS", manufacturer: "Chevrolet", type: "car" },
    { slug: "chevy-silverado-ss", name: "Chevrolet Silverado SS", manufacturer: "Chevrolet", type: "car" },
    { slug: "chevy-elcamino-ss", name: "Chevrolet El Camino SS", manufacturer: "Chevrolet", type: "car" },
    // Dodge (6)
    { slug: "dodge-challenger-hellcat", name: "Dodge Challenger SRT Hellcat", manufacturer: "Dodge", type: "car" },
    { slug: "dodge-charger-hellcat", name: "Dodge Charger SRT Hellcat", manufacturer: "Dodge", type: "car" },
    { slug: "dodge-viper-acr", name: "Dodge Viper ACR", manufacturer: "Dodge", type: "car" },
    { slug: "dodge-challenger-demon", name: "Dodge Challenger Demon", manufacturer: "Dodge", type: "car" },
    { slug: "dodge-neon-srt4", name: "Dodge Neon SRT-4", manufacturer: "Dodge", type: "car" },
    { slug: "dodge-charger-daytona", name: "Dodge Charger Daytona", manufacturer: "Dodge", type: "car" },
    // Lexus (6)
    { slug: "lexus-lfa", name: "Lexus LFA", manufacturer: "Lexus", type: "car" },
    { slug: "lexus-isf", name: "Lexus IS-F", manufacturer: "Lexus", type: "car" },
    { slug: "lexus-rcf", name: "Lexus RC F", manufacturer: "Lexus", type: "car" },
    { slug: "lexus-gs400", name: "Lexus GS400", manufacturer: "Lexus", type: "car" },
    { slug: "lexus-sc400", name: "Lexus SC400", manufacturer: "Lexus", type: "car" },
    { slug: "lexus-ls400", name: "Lexus LS400", manufacturer: "Lexus", type: "car" },

    // ============ MOTORCYCLES ============
    // Ducati (5 more — Panigale V4 is flagship)
    { slug: "ducati-panigale-v2", name: "Ducati Panigale V2", manufacturer: "Ducati", type: "motorcycle" },
    { slug: "ducati-streetfighter-v4", name: "Ducati Streetfighter V4", manufacturer: "Ducati", type: "motorcycle" },
    { slug: "ducati-diavel-v4", name: "Ducati Diavel V4", manufacturer: "Ducati", type: "motorcycle" },
    { slug: "ducati-xdiavel", name: "Ducati XDiavel", manufacturer: "Ducati", type: "motorcycle" },
    { slug: "ducati-monster", name: "Ducati Monster", manufacturer: "Ducati", type: "motorcycle" },
    // Honda (6)
    { slug: "honda-cbr1000rr-fireblade", name: "Honda CBR1000RR Fireblade", manufacturer: "Honda", type: "motorcycle" },
    { slug: "honda-cbr600rr", name: "Honda CBR600RR", manufacturer: "Honda", type: "motorcycle" },
    { slug: "honda-rc213v-s", name: "Honda RC213V-S", manufacturer: "Honda", type: "motorcycle" },
    { slug: "honda-rebel-1100", name: "Honda Rebel 1100", manufacturer: "Honda", type: "motorcycle" },
    { slug: "honda-shadow-phantom", name: "Honda Shadow Phantom", manufacturer: "Honda", type: "motorcycle" },
    { slug: "honda-gold-wing-tour", name: "Honda Gold Wing Tour", manufacturer: "Honda", type: "motorcycle" },
    // Yamaha (6)
    { slug: "yamaha-yzf-r1", name: "Yamaha YZF-R1", manufacturer: "Yamaha", type: "motorcycle" },
    { slug: "yamaha-yzf-r6", name: "Yamaha YZF-R6", manufacturer: "Yamaha", type: "motorcycle" },
    { slug: "yamaha-yzf-r7", name: "Yamaha YZF-R7", manufacturer: "Yamaha", type: "motorcycle" },
    { slug: "yamaha-bolt-r-spec", name: "Yamaha Bolt R-Spec", manufacturer: "Yamaha", type: "motorcycle" },
    { slug: "yamaha-v-star-1300", name: "Yamaha V Star 1300", manufacturer: "Yamaha", type: "motorcycle" },
    { slug: "yamaha-stryker", name: "Yamaha Stryker", manufacturer: "Yamaha", type: "motorcycle" },
    // Kawasaki (6)
    { slug: "kawasaki-ninja-h2", name: "Kawasaki Ninja H2", manufacturer: "Kawasaki", type: "motorcycle" },
    { slug: "kawasaki-ninja-zx10r", name: "Kawasaki Ninja ZX-10R", manufacturer: "Kawasaki", type: "motorcycle" },
    { slug: "kawasaki-ninja-zx6r", name: "Kawasaki Ninja ZX-6R", manufacturer: "Kawasaki", type: "motorcycle" },
    { slug: "kawasaki-vulcan-vaquero", name: "Kawasaki Vulcan Vaquero", manufacturer: "Kawasaki", type: "motorcycle" },
    { slug: "kawasaki-vulcan-s", name: "Kawasaki Vulcan S", manufacturer: "Kawasaki", type: "motorcycle" },
    { slug: "kawasaki-eliminator", name: "Kawasaki Eliminator", manufacturer: "Kawasaki", type: "motorcycle" },
    // Suzuki (6)
    { slug: "suzuki-gsxr1000", name: "Suzuki GSX-R1000", manufacturer: "Suzuki", type: "motorcycle" },
    { slug: "suzuki-gsxr750", name: "Suzuki GSX-R750", manufacturer: "Suzuki", type: "motorcycle" },
    { slug: "suzuki-hayabusa", name: "Suzuki Hayabusa GSX1300R", manufacturer: "Suzuki", type: "motorcycle" },
    { slug: "suzuki-boulevard-m109r", name: "Suzuki Boulevard M109R", manufacturer: "Suzuki", type: "motorcycle" },
    { slug: "suzuki-boulevard-c50", name: "Suzuki Boulevard C50", manufacturer: "Suzuki", type: "motorcycle" },
    { slug: "suzuki-boulevard-s40", name: "Suzuki Boulevard S40", manufacturer: "Suzuki", type: "motorcycle" },
    // BMW (6)
    { slug: "bmw-s1000rr", name: "BMW S1000RR", manufacturer: "BMW", type: "motorcycle" },
    { slug: "bmw-m1000rr", name: "BMW M1000RR", manufacturer: "BMW", type: "motorcycle" },
    { slug: "bmw-s1000r", name: "BMW S1000R", manufacturer: "BMW", type: "motorcycle" },
    { slug: "bmw-r18", name: "BMW R 18", manufacturer: "BMW", type: "motorcycle" },
    { slug: "bmw-r1250-gs", name: "BMW R 1250 GS", manufacturer: "BMW", type: "motorcycle" },
    { slug: "bmw-k1600-b", name: "BMW K 1600 B", manufacturer: "BMW", type: "motorcycle" },
    // Harley-Davidson (6)
    { slug: "harley-road-glide-st", name: "Harley-Davidson Road Glide ST", manufacturer: "Harley-Davidson", type: "motorcycle" },
    { slug: "harley-street-glide", name: "Harley-Davidson Street Glide", manufacturer: "Harley-Davidson", type: "motorcycle" },
    { slug: "harley-cvo-limited", name: "Harley-Davidson CVO Limited", manufacturer: "Harley-Davidson", type: "motorcycle" },
    { slug: "harley-fat-boy", name: "Harley-Davidson Fat Boy", manufacturer: "Harley-Davidson", type: "motorcycle" },
    { slug: "harley-softail-standard", name: "Harley-Davidson Softail Standard", manufacturer: "Harley-Davidson", type: "motorcycle" },
    { slug: "harley-sportster-s", name: "Harley-Davidson Sportster S", manufacturer: "Harley-Davidson", type: "motorcycle" },
    // Triumph (6)
    { slug: "triumph-daytona-765", name: "Triumph Daytona 765", manufacturer: "Triumph", type: "motorcycle" },
    { slug: "triumph-street-triple-rs", name: "Triumph Street Triple RS", manufacturer: "Triumph", type: "motorcycle" },
    { slug: "triumph-speed-triple-1200", name: "Triumph Speed Triple 1200", manufacturer: "Triumph", type: "motorcycle" },
    { slug: "triumph-bonneville-t120", name: "Triumph Bonneville T120", manufacturer: "Triumph", type: "motorcycle" },
    { slug: "triumph-thruxton-rs", name: "Triumph Thruxton RS", manufacturer: "Triumph", type: "motorcycle" },
    { slug: "triumph-rocket-3-r", name: "Triumph Rocket 3 R", manufacturer: "Triumph", type: "motorcycle" },
    // Indian (6)
    { slug: "indian-ftr-r-carbon", name: "Indian FTR R Carbon", manufacturer: "Indian", type: "motorcycle" },
    { slug: "indian-ftr-sport", name: "Indian FTR Sport", manufacturer: "Indian", type: "motorcycle" },
    { slug: "indian-challenger-dark-horse", name: "Indian Challenger Dark Horse", manufacturer: "Indian", type: "motorcycle" },
    { slug: "indian-chief-dark-horse", name: "Indian Chief Dark Horse", manufacturer: "Indian", type: "motorcycle" },
    { slug: "indian-scout-bobber", name: "Indian Scout Bobber", manufacturer: "Indian", type: "motorcycle" },
    { slug: "indian-vintage", name: "Indian Vintage", manufacturer: "Indian", type: "motorcycle" },
    // KTM (6)
    { slug: "ktm-rc-8c", name: "KTM RC 8C", manufacturer: "KTM", type: "motorcycle" },
    { slug: "ktm-rc-390", name: "KTM RC 390", manufacturer: "KTM", type: "motorcycle" },
    { slug: "ktm-super-duke-1290-r", name: "KTM Super Duke 1290 R", manufacturer: "KTM", type: "motorcycle" },
    { slug: "ktm-1290-adventure", name: "KTM 1290 Adventure", manufacturer: "KTM", type: "motorcycle" },
    { slug: "ktm-890-duke-r", name: "KTM 890 Duke R", manufacturer: "KTM", type: "motorcycle" },
    { slug: "ktm-690-smc-r", name: "KTM 690 SMC R", manufacturer: "KTM", type: "motorcycle" },

    // ============ TOP 50 LIST — Additional Stubs (Feb 2026 expansion) ============
    // JDM additions
    { slug: "toyota-gr86", name: "Toyota GR86", manufacturer: "Toyota", type: "car" },
    { slug: "scion-fr-s", name: "Scion FR-S", manufacturer: "Scion", type: "car" },
    { slug: "mazda-miata-nb", name: "Mazda MX-5 Miata NB", manufacturer: "Mazda", type: "car" },
    { slug: "mazda-miata-nc", name: "Mazda MX-5 Miata NC", manufacturer: "Mazda", type: "car" },
    { slug: "mazda-rx7-fb", name: "Mazda RX-7 FB", manufacturer: "Mazda", type: "car" },
    { slug: "mazda-rx7-fc", name: "Mazda RX-7 FC", manufacturer: "Mazda", type: "car" },
    { slug: "toyota-mr2-spyder-zzw30", name: "Toyota MR2 Spyder (ZZW30)", manufacturer: "Toyota", type: "car" },
    { slug: "nissan-240sx-s13", name: "Nissan 240SX (S13)", manufacturer: "Nissan", type: "car" },
    { slug: "nissan-180sx", name: "Nissan 180SX", manufacturer: "Nissan", type: "car" },
    { slug: "lexus-is300-altezza", name: "Lexus IS 300 / Altezza", manufacturer: "Lexus", type: "car" },
    { slug: "lancer-evo-viii", name: "Mitsubishi Lancer Evo VIII", manufacturer: "Mitsubishi", type: "car" },
    { slug: "nissan-350z", name: "Nissan 350Z", manufacturer: "Nissan", type: "car" },
    { slug: "nissan-370z", name: "Nissan 370Z", manufacturer: "Nissan", type: "car" },
    { slug: "subaru-wrx", name: "Subaru WRX (Base)", manufacturer: "Subaru", type: "car" },

    // American Muscle additions
    { slug: "ford-mustang-fox-body", name: "Ford Mustang (Fox Body)", manufacturer: "Ford", type: "car" },
    { slug: "ford-mustang-s550", name: "Ford Mustang S550", manufacturer: "Ford", type: "car" },
    { slug: "ford-mustang-s650", name: "Ford Mustang S650", manufacturer: "Ford", type: "car" },
    { slug: "chevy-corvette-c5", name: "Chevrolet Corvette C5", manufacturer: "Chevrolet", type: "car" },
    { slug: "chevy-corvette-c6", name: "Chevrolet Corvette C6", manufacturer: "Chevrolet", type: "car" },
    { slug: "chevy-corvette-c7", name: "Chevrolet Corvette C7", manufacturer: "Chevrolet", type: "car" },
    { slug: "ford-focus-st", name: "Ford Focus ST", manufacturer: "Ford", type: "car" },
    { slug: "ford-fiesta-st", name: "Ford Fiesta ST", manufacturer: "Ford", type: "car" },
    { slug: "dodge-charger", name: "Dodge Charger", manufacturer: "Dodge", type: "car" },
    { slug: "dodge-challenger", name: "Dodge Challenger", manufacturer: "Dodge", type: "car" },
    { slug: "jeep-wrangler", name: "Jeep Wrangler", manufacturer: "Jeep", type: "car" },
    { slug: "ford-ranger", name: "Ford Ranger", manufacturer: "Ford", type: "car" },
    { slug: "chevy-c10", name: "Chevrolet C10", manufacturer: "Chevrolet", type: "car" },

    // European Hot Hatches / Sport Sedans additions
    { slug: "vw-mk8-gti", name: "VW Mk8 GTI", manufacturer: "Volkswagen", type: "car" },
    { slug: "vw-golf-r32-mk4", name: "VW Mk4 Golf R32", manufacturer: "Volkswagen", type: "car" },
    { slug: "bmw-3-series-e36", name: "BMW 3 Series (E36)", manufacturer: "BMW", type: "car" },
    { slug: "bmw-3-series-e46", name: "BMW 3 Series (E46)", manufacturer: "BMW", type: "car" },
    { slug: "bmw-3-series-e90", name: "BMW 3 Series (E90)", manufacturer: "BMW", type: "car" },
    { slug: "bmw-3-series-f30", name: "BMW 3 Series (F30)", manufacturer: "BMW", type: "car" },
    { slug: "bmw-m4-f82-g82", name: "BMW M4 (F82 / G82)", manufacturer: "BMW", type: "car" },
    { slug: "bmw-1m", name: "BMW 1M Coupe", manufacturer: "BMW", type: "car" },
    { slug: "bmw-m2", name: "BMW M2", manufacturer: "BMW", type: "car" },
    { slug: "audi-rs4", name: "Audi RS4", manufacturer: "Audi", type: "car" },
    { slug: "audi-s3", name: "Audi S3", manufacturer: "Audi", type: "car" },
    { slug: "audi-rs3", name: "Audi RS3", manufacturer: "Audi", type: "car" },
    { slug: "audi-tt-mk2", name: "Audi TT (Mk2)", manufacturer: "Audi", type: "car" },
    { slug: "mercedes-e55-amg", name: "Mercedes-Benz E55 AMG", manufacturer: "Mercedes-AMG", type: "car" },
    { slug: "mercedes-a45-amg", name: "Mercedes-AMG A45", manufacturer: "Mercedes-AMG", type: "car" },
    { slug: "fiat-500-abarth", name: "Fiat 500 Abarth", manufacturer: "Fiat", type: "car" },
    { slug: "vw-beetle-new", name: "VW New Beetle", manufacturer: "Volkswagen", type: "car" },

    // Exotics, Super-SUVs & Luxury additions
    { slug: "porsche-911-964", name: "Porsche 911 (964)", manufacturer: "Porsche", type: "car" },
    { slug: "porsche-911-991", name: "Porsche 911 (991)", manufacturer: "Porsche", type: "car" },
    { slug: "porsche-911-992", name: "Porsche 911 (992)", manufacturer: "Porsche", type: "car" },
    { slug: "porsche-macan", name: "Porsche Macan", manufacturer: "Porsche", type: "car" },
    { slug: "porsche-cayenne", name: "Porsche Cayenne", manufacturer: "Porsche", type: "car" },
    { slug: "lamborghini-urus", name: "Lamborghini Urus", manufacturer: "Lamborghini", type: "car" },
    { slug: "lamborghini-huracan", name: "Lamborghini Huracán", manufacturer: "Lamborghini", type: "car" },
    { slug: "ferrari-458-italia", name: "Ferrari 458 Italia", manufacturer: "Ferrari", type: "car" },
    { slug: "ferrari-488-gtb", name: "Ferrari 488 GTB", manufacturer: "Ferrari", type: "car" },
    { slug: "mclaren-720s", name: "McLaren 720S", manufacturer: "McLaren", type: "car" },
    { slug: "mclaren-765lt", name: "McLaren 765LT", manufacturer: "McLaren", type: "car" },
    { slug: "bmw-x6", name: "BMW X6", manufacturer: "BMW", type: "car" },
    { slug: "bmw-x6-m", name: "BMW X6 M", manufacturer: "BMW", type: "car" },

    // Classic & Restomod additions
    { slug: "vw-beetle-classic", name: "Classic VW Beetle", manufacturer: "Volkswagen", type: "car" },
    { slug: "datsun-240z", name: "Datsun 240Z", manufacturer: "Datsun", type: "car" },
    { slug: "datsun-260z", name: "Datsun 260Z", manufacturer: "Datsun", type: "car" },
    { slug: "datsun-280z", name: "Datsun 280Z", manufacturer: "Datsun", type: "car" },
    { slug: "ford-deuce-coupe-1932", name: "1932 Ford \"Deuce\" Coupe", manufacturer: "Ford", type: "car" },
    { slug: "mercedes-sl-r107", name: "Mercedes-Benz SL (R107)", manufacturer: "Mercedes-Benz", type: "car" },
    { slug: "mercedes-sl-r129", name: "Mercedes-Benz SL (R129)", manufacturer: "Mercedes-Benz", type: "car" },
];

// Convenience selectors
export const CARS = BUILDS.filter((b) => b.type === "car");
export const MOTORCYCLES = BUILDS.filter((b) => b.type === "motorcycle");

export const BUILDS_BY_SLUG = BUILDS.reduce((acc, b) => {
    acc[b.slug] = b;
    return acc;
}, {});

// Generic resources to surface on stub pages (fallback by manufacturer)
export const MANUFACTURER_FALLBACK_RESOURCES = {
    Toyota: { forum: "https://www.club4ag.com", youtube: "https://www.youtube.com/results?search_query=toyota+build" },
    Nissan: { forum: "https://www.nissanforums.com", youtube: "https://www.youtube.com/results?search_query=nissan+build" },
    Honda: { forum: "https://www.hondatech.com", youtube: "https://www.youtube.com/results?search_query=honda+build" },
    Mazda: { forum: "https://www.rx7club.com", youtube: "https://www.youtube.com/results?search_query=mazda+build" },
    Mitsubishi: { forum: "https://www.evolutionm.net", youtube: "https://www.youtube.com/results?search_query=mitsubishi+build" },
    Subaru: { forum: "https://www.nasioc.com", youtube: "https://www.youtube.com/results?search_query=subaru+sti+build" },
    BMW: { forum: "https://www.bimmerforums.com", youtube: "https://www.youtube.com/results?search_query=bmw+m+build" },
    "Mercedes-AMG": { forum: "https://mbworld.org", youtube: "https://www.youtube.com/results?search_query=amg+build" },
    Audi: { forum: "https://www.audizine.com", youtube: "https://www.youtube.com/results?search_query=audi+rs+build" },
    Porsche: { forum: "https://rennlist.com", youtube: "https://www.youtube.com/results?search_query=porsche+gt3+build" },
    Volkswagen: { forum: "https://www.vwvortex.com", youtube: "https://www.youtube.com/results?search_query=volkswagen+golf+r+build" },
    Ford: { forum: "https://www.mustang7g.com", youtube: "https://www.youtube.com/results?search_query=mustang+build" },
    Chevrolet: { forum: "https://www.corvetteforum.com", youtube: "https://www.youtube.com/results?search_query=corvette+build" },
    Dodge: { forum: "https://www.challenger-forum.com", youtube: "https://www.youtube.com/results?search_query=hellcat+build" },
    Lexus: { forum: "https://www.clublexus.com", youtube: "https://www.youtube.com/results?search_query=lexus+lfa+build" },
    Ducati: { forum: "https://www.ducati.ms", youtube: "https://www.youtube.com/results?search_query=ducati+build" },
    Yamaha: { forum: "https://www.r1-forum.com", youtube: "https://www.youtube.com/results?search_query=yamaha+r1+build" },
    Kawasaki: { forum: "https://www.kawiforums.com", youtube: "https://www.youtube.com/results?search_query=kawasaki+ninja+build" },
    Suzuki: { forum: "https://www.gsxr.com", youtube: "https://www.youtube.com/results?search_query=gsxr+build" },
    "Harley-Davidson": { forum: "https://www.hdforums.com", youtube: "https://www.youtube.com/results?search_query=harley+davidson+build" },
    Triumph: { forum: "https://www.triumphrat.net", youtube: "https://www.youtube.com/results?search_query=triumph+build" },
    Indian: { forum: "https://www.indianmotorcycles.net", youtube: "https://www.youtube.com/results?search_query=indian+motorcycle+build" },
    KTM: { forum: "https://www.ktmtalk.com", youtube: "https://www.youtube.com/results?search_query=ktm+duke+build" },
    Scion: { forum: "https://www.scionlife.com", youtube: "https://www.youtube.com/results?search_query=scion+fr-s+build" },
    Jeep: { forum: "https://www.wranglerforum.com", youtube: "https://www.youtube.com/results?search_query=jeep+wrangler+build" },
    Fiat: { forum: "https://www.fiat500usaforum.com", youtube: "https://www.youtube.com/results?search_query=fiat+500+abarth+build" },
    Lamborghini: { forum: "https://www.lambo-talk.com", youtube: "https://www.youtube.com/results?search_query=lamborghini+huracan+build" },
    Ferrari: { forum: "https://www.ferrarichat.com", youtube: "https://www.youtube.com/results?search_query=ferrari+488+build" },
    McLaren: { forum: "https://mclarenlife.com", youtube: "https://www.youtube.com/results?search_query=mclaren+720s+build" },
    Datsun: { forum: "https://www.classiczcars.com", youtube: "https://www.youtube.com/results?search_query=datsun+240z+build" },
    "Mercedes-Benz": { forum: "https://mbworld.org", youtube: "https://www.youtube.com/results?search_query=mercedes+sl+restomod" },
};
